@if (child()) {
  @for (loopChild of child().children; track $index) {
    @if (loopChild.type === 'container') {
      <layout-container
        [child]="loopChild"
        [config]="config()"
        [content]="content()"
        [options]="options()"
        [context]="context()"
        (renderEvent)="renderEvent.emit($event)"
      ></layout-container>
    }

    @if (loopChild.type === 'logo') {
      @defer {
        <layout-logo [child]="loopChild" [config]="config()" [content]="content()" [options]="options()" (renderEvent)="renderEvent.emit($event)">
        </layout-logo>
      }
    }

    @if (loopChild.type === 'button') {
      @defer {
        <layout-button
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
          (buttonEvent)="renderEvent.emit($event)"
        ></layout-button>
      }
    }

    @if (loopChild.type === 'title' && content().typeSpecific.style.title.enabled) {
      @defer {
        <layout-title
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-title>
      }
    }

    @if (loopChild.type === 'subTitle' && content().typeSpecific.style.subTitle.enabled) {
      @defer {
        <layout-subtitle
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-subtitle>
      }
    }

    @if (loopChild.type === 'description' && content().typeSpecific.style.description.enabled) {
      @defer {
        <layout-description
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-description>
      }
    }

    @if (loopChild.type === 'info') {
      @defer {
        <layout-info [child]="loopChild" [config]="config()" [content]="content()" [options]="options()" (renderEvent)="renderEvent.emit($event)"></layout-info>
      }
    }

    @if (loopChild.type === 'source') {
      @defer {
        <layout-source
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-source>
      }
    }

    @if (loopChild.type === 'filter' && content().typeSpecific.inVisualFilter) {
      @defer {
        <layout-filter
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-filter>
      }
    }

    @if (loopChild.type === 'filter-annotation') {
      @defer {
        <layout-filter-annotation
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-filter-annotation>
      }
    }

    @if (loopChild.type === 'legend' && isChart(content().type) && content().typeSpecific.chart.legend.enabled && !isTTChartType(content().type)) {
      @defer {
        <layout-legend
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-legend>
      }
    }

    @if (loopChild.type === 'overlay') {
      @defer {
        <layout-overlay
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
        ></layout-overlay>
      }
    }

    @if (loopChild.type === 'menu') {
      @defer {
        <layout-menu
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
          (menuEvent)="renderEvent.emit($event)"
        ></layout-menu>
      }
    }

    @if (loopChild.type === 'navigation') {
      @defer {
        <layout-navigation
          [child]="loopChild"
          [config]="config()"
          [content]="content()"
          [options]="options()"
          (renderEvent)="renderEvent.emit($event)"
          (navEvent)="renderEvent.emit($event)"
        ></layout-navigation>
      }
    }

    @if (isMap(content().type)) {
      @if (loopChild.type === 'search') {
        @defer {
          <layout-search
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
            (searchEvent)="renderEvent.emit($event)"
          >
          </layout-search>
        }
      }

      @if (loopChild.type === 'map-legend' && content().type !== 'multimap') {
        @defer {
          <layout-map-legend
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
          ></layout-map-legend>
        }
      }

      @if (loopChild.type === 'map-layers-legend') {
        @defer {
          <layout-map-layers-legend
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
          ></layout-map-layers-legend>
        }
      }

      @if (loopChild.type === 'map-attributions') {
        @defer {
          <layout-map-attributions
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
          ></layout-map-attributions>
        }
      }
    }

    @if (loopChild.type === 'visual') {
      @if (isLegacyChart(content().type)) {
        @defer {
          <layout-chart
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [context]="context()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
            (chartEvent)="renderEvent.emit($event)"
          ></layout-chart>
        }
      }

      @if (isTTChartType(content().type)) {
        @defer {
          <layout-tt-charts
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [context]="context()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
            (chartEvent)="renderEvent.emit($event)"
          ></layout-tt-charts>
        }
      }

      @if (isEChartType(content().type)) {
        @defer {
          <layout-echarts
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [context]="context()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
          ></layout-echarts>
        }
      }

      @if (isMap(content().type)) {
        @defer {
          <layout-map
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [context]="context()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
            (mapEvent)="renderEvent.emit($event)"
          >
          </layout-map>
        }
      }

      @if (isTableV1(content().type)) {
        @defer {
          <layout-table
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [context]="context()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
          ></layout-table>
        }
      }

      @if (isTableV2(content().type)) {
        @defer {
          <layout-table2
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [context]="context()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
          ></layout-table2>
        }
      }

      @if (isDash(content().type)) {
        @defer {
          <layout-dash
            [child]="loopChild"
            [config]="config()"
            [content]="content()"
            [context]="context()"
            [options]="options()"
            (renderEvent)="renderEvent.emit($event)"
          ></layout-dash>
        }
      }
    }

    @if (loopChild.type === 'content-selector' && config().activeChild?.slug) {
      @defer {
        <content-selector2 ngSkipHydration [slug]="config().activeChild.slug" [options]="options()"></content-selector2>
      }
    }
  }
}
